import HTTP from '@/plugins/http'

export const state = {
  planWhispers: [],
  ratePlans: [],
  templates: [],
  tempPlans: [],
  searchResults: [],
  planSearch: {
    keyword: null,
    pageSize: 50
  }
}

export const getters = {
  planWhispers: state => {
    return state.planWhispers
  },
  ratePlans: state => {
    return state.ratePlans
  },
  templates: state => {
    return state.templates
  },
  tempPlans: state => {
    return state.tempPlans
  },
  searchResults: state => {
    return state.searchResults
  }
}

export const mutations = {
  SET_PLAN_WHISPERS (state, data) {
    state.planWhispers = data
  },
  SET_RATE_PLANS (state, data) {
    state.ratePlans = data
  },
  SET_TEMPLATES (state, data) {
    state.templates = data
  },
  SET_WHOLESALE_PLAN (state, data) {
    data.plan.wholesalePlanId = data.wholesalePlanId
  },
  SET_UTILIBILL_PLAN (state, data) {
    data.plan.staticIPPlan = data.staticIPPlan
  },
  ADD_TEMP_PLAN (state, data) {
    const isExisting = state.tempPlans.some(x => x.planWhisperId == data.plan.planWhisperId)

    if (!isExisting) {
      state.tempPlans.push(data.plan)
    } else {
      const plan = state.tempPlans.filter(x => x.planWhisperId == data.plan.planWhisperId)

      if (typeof data.wholesalePlanId !== 'undefined') { plan[0].wholesalePlanId = data.wholesalePlanId }

      if (typeof data.staticIPPlan !== 'undefined') { plan[0].staticIPPlan = data.staticIPPlan }
    }
  },
  REMOVE_ITEM_FROM_TEMP_PLANS (state, data) {
    const isExisting = state.tempPlans.some(x => x.planWhisperId == data.planWhisperId)

    if (isExisting) {
      const index = state.tempPlans.findIndex(x => x.planWhisperId == data.planWhisperId)

      if (index < 0) { return }

      state.tempPlans.splice(index, 1)
    }
  },
  CLEAR_TEMP_PLANS (state) {
    state.tempPlans = []
  },
  SET_SEARCH_PLANS (state, data) {
    state.searchResults = state.planWhispers.filter(x => x.wgPlanName.includes(data))
    state.searchResults
  },
  CLEAR_SEARCH_RESULTS (state) {
    state.searchResults = []
  },
  SET_PLAN_SEARCH (state, data) {
    state.planSearch = data
  },
  SET_PAGE_SIZE (state, data) {
    state.planSearch.pageSize = data
  }
}

export const actions = {
  response ({}, data) {
    this.dispatch('httpResponse/setHttpResponse',
      { text: data.message, color: data.color },
      { root: true })
  },
  loader ({}, data) {
    const process = data ? 'setProcessActive' : 'setProcessInactive'
    this.dispatch(`httpResponse/${process}`)
  },
  async getPlanWhispers ({ commit, dispatch, state }) {
    dispatch('loader', true)
    try {
      const result = await HTTP.post('WG/GetPlanWhispers', state.planSearch)
      const resultData = parseInt(result.status) === 200 ? result.data : []
      commit('SET_PLAN_WHISPERS', resultData)
      dispatch('loader', false)
      return Promise.resolve(result.data)
    } catch (e) {
      dispatch('response', { message: e.message, color: 'error' })
      dispatch('loader', false)
      return Promise.reject(e.message)
    }
  },
  async getRatePlans ({ commit, dispatch }) {
    dispatch('loader', true)
    try {
      const result = await HTTP.get('WG/GetRatePlans')
      const resultData = parseInt(result.status) === 200 ? result.data : []
      commit('SET_RATE_PLANS', resultData)
      dispatch('loader', false)
      return Promise.resolve(result.data)
    } catch (e) {
      dispatch('response', { message: e.message, color: 'error' })
      dispatch('loader', false)
      return Promise.reject(e.message)
    }
  },
  async getTemplates ({ commit, dispatch }) {
    dispatch('loader', true)
    try {
      const result = await HTTP.get('WG/GetTemplates')
      const resultData = parseInt(result.status) === 200 ? result.data : []
      commit('SET_TEMPLATES', resultData)
      dispatch('loader', false)
      return Promise.resolve(result.data)
    } catch (e) {
      dispatch('response', { message: e.message, color: 'error' })
      dispatch('loader', false)
      return Promise.reject(e.message)
    }
  },
  async updatePlanWhisper ({ commit, dispatch }, payload) {
    dispatch('loader', true)
    try {
      const result = await HTTP.post('WG/UpdatePlanWhisper', payload)
      commit('REMOVE_ITEM_FROM_TEMP_PLANS', payload)
      dispatch('loader', false)
      return Promise.resolve(result.data)
    } catch (e) {
      dispatch('response', { message: e.message, color: 'error' })
      dispatch('loader', false)
      return Promise.reject(e.message)
    }
  },
  async bulkUpdatePlanWhisper ({ commit, dispatch, state }) {
    dispatch('loader', true)
    try {
      const result = await HTTP.post('WG/BulkUpdatePlanWhisper', state.tempPlans)
      commit('CLEAR_TEMP_PLANS')
      dispatch('loader', false)
      return Promise.resolve(result.data)
    } catch (e) {
      dispatch('response', { message: e.message, color: 'error' })
      dispatch('loader', false)
      return Promise.reject(e.message)
    }
  },
  changeWholesalePlan ({ commit }, data) {
    commit('SET_WHOLESALE_PLAN', data)
  },
  changeUtilibillPlan ({ commit }, data) {
    commit('SET_UTILIBILL_PLAN', data)
  },
  addTempPlan ({ commit }, data) {
    commit('ADD_TEMP_PLAN', data)
  },
  clearTempPlans ({ commit }) {
    commit('CLEAR_TEMP_PLANS')
  },
  searchPlans ({ commit }, data) {
    commit('SET_SEARCH_PLANS', data)
  },
  clearSearchResults ({ commit }) {
    commit('CLEAR_SEARCH_RESULTS')
  },
  setPlanSearch ({ commit }, data) {
    commit('SET_PLAN_SEARCH', data)
  },
  setPageSize ({ commit }, data) {
    commit('SET_PAGE_SIZE', data)
  }
}
